import React 			from 'react';
import ReactDOM 		from 'react-dom';
import BLComponent			from '../../core/_BLComponent.jsx';

export default class BDPProgressBar extends BLComponent {
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = '', progress, fundedLimit, funded, soldOut} = this.props; 
		const progressPosition = progress * 100;
		const fundedPositionPercent = fundedLimit * 100;
		const status = progressPosition >= 100 || soldOut ? 'sold-out' : funded ? 'funded' : 'in-progress';
		
		return (
			<div className={`bdp-progress-bar bdp-progress-bar--${status} bdp-progress-bar--series ${classes}`}>
				<div className="bdp-progress-bar__bar-wrapper">
					<div className="bdp-progress-bar__bar">
						<div data-ts-name="bdp-progress__progress" className="bdp-progress-bar__bar-blocker" style={{marginLeft: progressPosition + '%'}}/>
					</div>
					<div className="bdp-progress-bar__bar-milestone" style={{left: fundedPositionPercent + '%'}}></div>
					<div className="bdp-progress-bar__bar-milestone" style={{left: '100%'}}></div>
				</div>
				{funded ? 
					<div className={`bdp-progress-bar__limit bdp-progress-bar__limit--funded`} style={{left: fundedPositionPercent + '%'}}>
						<p data-ts-name="bdp-progress__limit-message" className="bdp-progress-bar__limit-message"><i className="fas fa-check-circle l-margin-right--xs"/>Funded</p>
					</div>
				:
					<div className="bdp-progress-bar__limit">
						<p data-ts-name="bdp-progress__limit-message" className="bdp-progress-bar__limit-message text--bold">Not funded</p>
					</div>
				}
				<div className="bdp-progress-bar__limit bdp-progress-bar__limit--max">
					<p className="bdp-progress-bar__limit-message" data-ts-name="bdp-progress__limit-message">{progressPosition >= 100 || soldOut ? 'Sold out' : 'Max'}</p>
				</div>
			</div>
		);
	}
}